import React, { useState } from 'react';
import { useWizard } from '../../../../../components/wizard/WizardContext';
import StudentDetails from '../../multiTypeRefund/selectRefundItems/StudentDetails';
import { studentDetailsLabelFieldMapping, useCheckForRefundEdit } from '../../multiTypeRefund/utils';
import { initiateCompletionRefund } from '../utils';
import RefundAccountsCard from '../../multiTypeRefund/selectRefundAccounts/RefundAccountsCard';
import ALoader from '../../../../../views/pages/manage/common/a-loader';
import EyeIcon from "assets/img/svg/svgComponents/EyeIcon";
import Footer from '../../../../studentTransfer/components/Footer';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import RectRefundInitSuccessDialog from '../../rectificationRefund/verifyDetails/RectRefundInitSuccessDialog';


const VerifyCompletionRefundDetails = ({
}) => {

    const { values, dropdowns } = useWizard();
    const forRefundEdit = useCheckForRefundEdit();
    const { selectedStudent, completionRefundStep2Data = {}, completionRefundUtils } = values;

    const [loading, setLoading] = useState(false);

    const [successDialogInfo, setSuccessDialogInfo] = useState({});

    const { primaryStudentAccount, payableRefundInfo } = completionRefundStep2Data;



    const issueRefundClickHandler = async () => {
        try {
            setLoading(true);
            const resp = await initiateCompletionRefund({ values, forRefundEdit });
            if (resp?.code === 200) {
                const { createdOn, createdBy, updatedBy, refundNumber, response = [] } = resp?.data ?? {};
                setSuccessDialogInfo({ isOpen: true, createdOn, createdBy: updatedBy || createdBy, refundNumber });
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className='d-flex flex-column m-2' style={{ gap: '1rem' }}>
            {loading && <ALoader position={"fixed"} />}

            <StudentDetails
                studentDetails={selectedStudent}
                labelFieldMappings={studentDetailsLabelFieldMapping(selectedStudent, dropdowns?.data)}
            />

            <RefundAccountsCard
                accountDetails={[primaryStudentAccount]}
                multiTypeRefundUtils={completionRefundUtils}
                title={"Student Refund Accounts"}
                openDetailsDialogIcon={<EyeIcon />}
                amount={payableRefundInfo?.totalRefundableAmount}
                primaryStudentAccount={primaryStudentAccount}
                viewOnly={true}
            />

            <Footer>
                <div>Verify Details</div>
                <AButton
                    onClick={issueRefundClickHandler}
                    className="button_remove_left_margin"
                    variant="primary_filled"
                >
                    Verify and issue refund
                </AButton>
            </Footer>

            <RectRefundInitSuccessDialog
                dialogInfo={successDialogInfo}
            />
        </div>


    );
}

export default VerifyCompletionRefundDetails;